import styled, { css } from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

export enum Size {
  l = 'large',
  m = 'medium',
  s = 'small',
}

export const TabsWrapper = styled.div`
  border-bottom: 1px solid #d7dce9;
  margin-bottom: 16px;
`;

export const TabsContent = styled.div`
  display: flex;
  position: relative;

  .anticon {
    transition: transform 0.24s;
  }

  .ant-dropdown-open {
    color: ${colors.blue500};

    .anticon {
      transform: rotate(180deg);
    }
  }
`;

export const StyledTab = styled.div<{
  size: Size;
  disabled?: boolean;
  active: boolean;
  isEmpty?: boolean;
}>`
  position: relative;
  font-size: 14px;
  line-height: 24px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: ${({ size }) =>
    size === Size.m ? '8px 16px 11px' : size === Size.l ? '17px 16px 19px' : '4px 16px 7px'};
  color: ${({ disabled, active }) =>
    disabled ? colors.gray400 : active ? colors.blue600 : colors.gray900};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  ${({ isEmpty }) =>
    isEmpty &&
    css`
      visibility: hidden;
      position: absolute;
    `}

  &:hover {
    color: ${({ disabled, active }) =>
      disabled ? colors.gray400 : active ? colors.blue600 : colors.blue500};
  }
`;

export const InkBar = styled.div<{ width: number; left: number }>`
  width: ${({ width }) => `${width}px`};
  background: ${colors.blue600};
  height: 2px;
  border-radius: 16px 16px 0px 0px;
  position: absolute;
  bottom: 0;
  left: ${({ left }) => `${left}px`};
  transition:
    width 0.3s,
    left 0.3s;
`;
